import { useBankProfile } from '@contexts/BankProfileContext.tsx';
import { Chip, Loader } from '@gurupay/gp-ui-library';
import { useTranslation } from 'react-i18next';

export const ProfileStatusChip = () => {
	const { t } = useTranslation('', { keyPrefix: 'statusWidget.status' });
	const { selectedProfile } = useBankProfile();
	const { status, odd_eligible: hasOdd } = selectedProfile ?? {};

	if (!selectedProfile) {
		return <Loader className="!w-space-16 !h-space-16" />;
	}

	if (hasOdd) {
		return (
			<Chip color="warning" label={t('actionRequired')} size="small" variant="filled" />
		);
	}

	if (status === 'dormant') {
		return <Chip color="neutral" label={t('inactive')} size="small" variant="filled" />;
	}

	return <Chip color="success" label={t('active')} size="small" variant="filled" />;
};
